import * as Yup from 'yup';

const schema = Yup.object().shape({
  text: Yup.string().required('O texto não pode ser vazio'),
});

export default schema;
